// composable: useUserApi.ts
import { inject, InjectionKey } from 'vue';
import { UserApiService } from './userApiService';

export const USER_API_KEY: InjectionKey<UserApiService> = Symbol('UserApiService');

export function useUserApi(): UserApiService {
	const service = inject<UserApiService>(USER_API_KEY);
	if (!service) throw new Error('UserApiService not provided');
	return service;
}
